<script>
import { mapState } from 'vuex'
import ExtraList from '@components/extra-list'
import ExtraDetail from '@components/extra-detail'

export default {
  metaInfo: {
    title: 'Extra',
    meta: [{ name: 'description', content: 'Extra' }],
  },

  components: { ExtraList, ExtraDetail },

  data() {
    return {
      item: {},
      currentView: 'ExtraList',
    }
  },

  computed: {
    ...mapState('app', ['currentProperty']),
    currentProps() {
      const props = { propertyId: this.currentProperty.id }

      if (this.currentView === 'ExtraDetail') {
        props.item = this.item
      }

      return props
    },
  },

  methods: {
    onEvent(data) {
      this.currentView = data.currentView
      this.item = data.item ? data.item : {}
    },
  },
}
</script>

<template>
  <component :is="currentView" v-bind="currentProps" @event="onEvent" />
</template>
